import { createI18n } from 'vue-i18n'
import en from './en'
import zh from './zh'
import jp from './jp'

// 准备语言包
const messages = {
    en,
    zh,
    jp
}

// 获取当前语言的函数
const getCurrentLanguage = () => {
    // 优先级1: 检查本地存储
    const storedLang = localStorage.getItem('lang');
    if (storedLang) {
        console.log('使用本地存储语言:', storedLang);
        return storedLang;
    }

    // 优先级2: 检查浏览器语言
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang) {
        console.log('检测到的浏览器语言111:', browserLang);

        // 将浏览器语言映射到支持的语言代码
        const mappedLang = mapBrowserLanguage(browserLang);

        console.log('请求头部传递:', mappedLang);


        if (mappedLang) {
            // 可选: 将检测到的浏览器语言保存到本地存储
            localStorage.setItem('lang', mappedLang);
            return mappedLang;
        }
    }

    // 优先级3: 使用默认语言
    console.log('使用默认语言: zh-cn');
    return 'zh-cn';
};

// 将浏览器语言映射到应用支持的语言代码
const mapBrowserLanguage = (browserLang) => {
    const lang = browserLang.toLowerCase();

    // 支持中文变体
    if (lang.startsWith('zh')) {
        // 可以根据需要返回 'zh-cn' 或 'zh-tw' 等
        return 'zh-cn';
    }

    // 支持英文变体
    if (lang.startsWith('en')) {
        return 'en-us';
    }

    // 添加其他语言支持...
    if (lang.startsWith('ja')) {
        return 'jp';
    }

    if (lang.startsWith('ko')) {
        return 'ko';
    }

    // 如果没有匹配的支持语言，返回 null
    return null;
};

// 创建 i18n 实例
const i18n = createI18n({
    legacy: false, // 使用 Composition API 模式
    locale: getCurrentLanguage(), // 应用优先级逻辑
    fallbackLocale: 'zh-cn', // 备用语言
    messages
});

export default i18n